/* unplugin-vue-components disabled */import { render } from "./supplypay.vue?vue&type=template&id=3690b0a4&scoped=true"
import script from "./supplypay.vue?vue&type=script&lang=js"
export * from "./supplypay.vue?vue&type=script&lang=js"

import "./supplypay.vue?vue&type=style&index=0&id=3690b0a4&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3690b0a4"]])

export default __exports__